import { Close } from '@mui/icons-material';
import { Box, IconButton, Modal, Paper } from '@mui/material';

export function FSModal({
  children,
  open,
  onClose,
  maxWidth,
  width,
  showCloseButton = false,
  disableCloseOnBackdropClick = false,
}: {
  children?: React.ReactNode;
  open: boolean;
  onClose?: () => void;
  maxWidth?: number | string;
  width?: number | string;
  showCloseButton?: boolean;
  disableCloseOnBackdropClick?: boolean;
}) {
  const handleOnClose = () => {
    if (onClose) onClose();
  };

  const onCloseModal = (event: object, reason: string) => {
    if (reason === 'backdropClick' && disableCloseOnBackdropClick) {
      return;
    } else if (reason === 'escapeKeyDown') {
      return; // do not close on escape key press
    }
    handleOnClose();
  };

  return (
    <Modal
      open={open}
      onClose={onCloseModal}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '10px',
      }}
    >
      <Paper
        sx={{
          overflow: 'auto',
          padding: '20px',
          borderRadius: '28px',
          width: width || '100%',
          maxWidth: maxWidth || 500,
          maxHeight: '100%',
        }}
      >
        <>
          {showCloseButton && (
            <CloseButtonTopRight onClickClose={handleOnClose} />
          )}
          {children}
        </>
      </Paper>
    </Modal>
  );
}

function CloseButtonTopRight({ onClickClose }: { onClickClose: () => void }) {
  return (
    <Box sx={{ position: 'relative' }}>
      <Box sx={{ position: 'absolute', right: 0 }}>
        <IconButton onClick={onClickClose}>
          <Close />
        </IconButton>
      </Box>
    </Box>
  );
}
